import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import MuiToggleSwitch from "../miui-component/mui-switch";

const MultiSeriesBarChart =({ data, duration }) => {
  console.log(data,duration)
    const color1 = "#cbeceff5";
    const color2 = "#495A69";
    const color3 = "#A6BED2A3";
  const [chartData, setChartData] = useState({
    series: [
      { name: "Pending", data: [] },
      { name: "Closed", data: [] },
      
    ],
    
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true, // Stack bars for comparison
        toolbar: {
          tools: {
            download: false, // Enables the download button
          },
        }
       
      },
      xaxis: {
        categories: [], // Placeholder for date labels
      },
    
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "top",
        },
        colors: [color2, color1, color3], // Custom colors for bars
    },
  });

  useEffect(() => {
    if(data.length){
      createDataForGraph();

    }
  }, [data,duration]);

  const createDataForGraph = () => {
    const dates = [];
    const revenueData = [];
    const incomeData = [];
    
      if(duration === 'Today'){
        dates.push(data[0].date)
        let pendingStatus = data[0].statuses.find(item => item.status === "PENDING");
        let completedStatus = data[0].statuses.find(item => item.status === "CLOSED");
        revenueData.push(Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0))
        incomeData.push(Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0))
        
      }
      if(duration === 'Yesterday') {
        dates.push(data[1].date)
        let pendingStatus = data[1].statuses.find(item => item.status === "PENDING");
        let completedStatus = data[1].statuses.find(item => item.status === "CLOSED");
        revenueData.push(Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0))
        incomeData.push(Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0))
  
       
       }
       if(duration === 'Monthly') {
        for (let i=0; i < data.length; i++) {
          
          let pendingStatus = data[i].statuses.find(item => item.status === "PENDING");
          let completedStatus = data[i].statuses.find(item => item.status === "CLOSED");
          revenueData.push(Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0))
          incomeData.push(Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0))
  
          
          dates.push(data[i].date)
       }
      }
      if (duration === 'Weekly') {
        const today = data[0].date; // Get the 'today' date from the data (e.g., "2025-01-27")
        
        // Convert the 'today' date to a Date object
        const todayDate = new Date(today);
      
        // Loop through the data and filter for the last 7 days
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          const itemDate = new Date(item.date); // Convert the item date to a Date object
          const diffTime = todayDate - itemDate; // Get the difference in time between today and the item date
          const diffDays = diffTime / (1000 * 3600 * 24); // Convert the difference from milliseconds to days
      
          // Only process data if the date is within the last 7 days
          if (diffDays >= 0 && diffDays <= 7) {
            dates.push(item.date); // Push the date to the dates array
      
            let pendingStatus = item.statuses.find(status => status.status === "PENDING");
            let completedStatus = item.statuses.find(status => status.status === "CLOSED");
      
            revenueData.push(Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0));
            incomeData.push(Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0));
          }
        }
      }
      
 
    // Update the chart with generated data
    setChartData((prevData) => ({
      ...prevData,
      series: [
        { name: "Pending", data: revenueData },
        { name: "Closed", data: incomeData },
      
      ],
      options: { ...prevData.options, xaxis: { categories: dates } },
    }));
  }

  return (
    <div>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default MultiSeriesBarChart;
